import React from 'react';
import Chip from '@material-ui/core/Chip';
import clsx from 'clsx';
import capitalize from 'lodash/capitalize';
import { getEnrollmentStatusClass } from 'utils/EnrollmentUtils';
import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
    createStyles({
        customBadge: {
            'display': 'inline-flex',
            'alignItems': 'center',
            'justifyContent': 'center',
            'borderRadius': 50,
            'color': '#fff',
            'fontSize': 15,
            'transform': 'none',
            'position': 'relative',
            'padding': '0px',
            'height': '27px',
            'fontWeight': 500,
            '& .MuiChip-label': {
                overflow: 'visible'
            }
        },
        badgeActive: {
            backgroundColor: '#5E8677'
        },
        badgePending: {
            backgroundColor: '#EAB464'
        },
        badgeCanceled: {
            backgroundColor: '#EF4F57'
        },
        badgePaused: {
            backgroundColor: '#F4F3F0',
            color: '#000'
        },
        badgePastDue: {
            backgroundColor: '#FFE5E7',
            color: '#CC444B'
        }
    })
);

interface Props {
    status: string;
    className?: string;
}

const EnrollmentStatusChip: React.FC<Props> = ({ status, className }) => {
    const classes = useStyles();
    return (
        <Chip
            className={clsx(
                classes.customBadge,
                classes[getEnrollmentStatusClass(status) as keyof typeof classes],
                className
            )}
            label={capitalize(status).replace('_', ' ')}
        />
    );
};

export default EnrollmentStatusChip;
